import PropTypes from "prop-types";
import React, { useState } from "react";
import submit from "submit-form";
import CalendarExerciseRow from "./CalendarExerciseRow";
import Avatar from "../../../../parts/avatar";
import HeaderWeek from "./HeaderWeek";
import SvgIcon from "../../../../parts/SvgIcon";

const {
  DATE_FORMATS: { DATE_DAY_FORMAT },
  defaultFirebaseProjectId,
} = require("../../../../constants");

const displayNotes = (notes, athlete) => {
  if (notes && notes.note) {
    return (
      <div className="wnotes">
        <Avatar size={23} className="note-avatar" user={athlete} />
        <p className="p1 wnote">{notes.note.toString()}</p>
      </div>
    );
  }
};

const displayCoachNotes = (notes, coach) => {
  if (notes && notes.note) {
    return (
      <div className="wnotes">
        <Avatar size={23} className="note-avatar" user={coach} />
        <p className="p1 wnote">{notes.note.toString()}</p>
      </div>
    );
  }
};

const WeekDay = (
  { date, notes, coachNotes, dailyStats },
  {
    locals: {
      query = {},
      athlete,
      activeUser,
      activeUserToRequest,
      coachOrganizationInformation,
      scheduledSessions = [],
    },
  }
) => {
  const [openQuickEditCoachNotes, setOpenQuickEditCoachNotes] = useState(false);
  const [coachNoteState, setCoachNoteState] = useState(coachNotes?.note || "");

  const dayString = date.clone().format(DATE_DAY_FORMAT);
  const exercises = scheduledSessions[dayString];

  const handleFocus = (e) => {
    e.target.focus();
    e.target.value = "";
    e.target.value = coachNoteState;
  };

  const openQuickEditCoachNotesHandler = () => setOpenQuickEditCoachNotes(true);

  const closeQuickEditCoachNotesHandler = () =>
    setOpenQuickEditCoachNotes(false);

  const handleCoachNoteChange = (e) => setCoachNoteState(e.target.value);

  const saveQuickEditCoachNotesHandler = (e) => {
    e.preventDefault();
    submit("/actions/exercise/quick-edit-coach-note", {
      method: "POST",
      body: {
        note: coachNoteState,
        date: dayString,
        user: query.athlete,
        coach: query.organizationCoach || activeUser._id,
        avatar:
          !!activeUser.avatar && !!activeUser.avatar.file
            ? activeUser.avatar.file
            : null,
        firebaseProjectId: !!activeUserToRequest.firebaseProjectId
          ? activeUserToRequest.firebaseProjectId
          : defaultFirebaseProjectId,
      },
    });
    closeQuickEditCoachNotesHandler();
  };

  return exercises ? (
    <article className="week-day">
      <HeaderWeek
        date={date}
        query={query}
        activeUser={activeUser}
        dailyStats={dailyStats}
      />

      <ul className="exercises-list">
        {exercises.map((exercise, index) =>
          exercise ? (
            <CalendarExerciseRow
              key={exercise._id}
              exercise={exercise}
              isWeekView
              exercises={exercises}
              exerciseOrder={index}
            />
          ) : null
        )}
      </ul>

      <footer>
        {displayNotes(notes, athlete)}
        <div className="flex items-center gap-2">
          <Avatar
            size={23}
            className="note-avatar"
            user={coachOrganizationInformation}
          />

          {openQuickEditCoachNotes ? (
            <>
              <textarea
                autoFocus
                className="max-w-[30rem]"
                name="notes"
                defaultValue={coachNoteState.trim()}
                onFocus={handleFocus}
                onChange={handleCoachNoteChange}
                placeholder="Coach notes for this workout"
              />
              <button
                onClick={saveQuickEditCoachNotesHandler}
                data-button-type="primary"
              >
                Save
              </button>
              <button
                onClick={closeQuickEditCoachNotesHandler}
                className="!text-[--danger]"
                data-button-type="secondary"
              >
                Cancel
              </button>
            </>
          ) : (
            <p className="p1 wnote">
              {coachNotes && coachNotes.note ? coachNotes.note.trim() : ""}
            </p>
          )}

          {!openQuickEditCoachNotes && (
            <button
              data-button-type="text"
              onClick={openQuickEditCoachNotesHandler}
              className="font-bold"
            >
              {coachNotes?.note ? (
                <SvgIcon src="/img/new-icons/edit-pencil.svg" />
              ) : (
                "Click to add coach notes"
              )}
            </button>
          )}
        </div>
      </footer>
    </article>
  ) : (
    <article className="week-empty-day">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <p className="s1 clipped">{date.format("MMM D")}</p>
          <p className="s1">{date.format("dddd")}</p>
        </div>

        <a
          data-button-type="primary"
          role="button"
          href={`/actions/refresh?modal[type]=calendar-add-exercise&day=${date.format(
            DATE_DAY_FORMAT
          )}`}
        >
          <SvgIcon src="/img/new-icons/add.svg" noFilterOnLight={true} />
          Add Exercise
        </a>
      </div>

      {notes?.note || coachNotes?.note ? (
        <div className="flex flex-col gap-4 mt-4">
          {displayNotes(notes, athlete)}
          {displayCoachNotes(coachNotes, activeUser)}
        </div>
      ) : null}
    </article>
  );
};

WeekDay.contextTypes = { locals: PropTypes.object };

export default WeekDay;
